import _extends from '@babel/runtime/helpers/esm/extends';
import React from 'react';
import { Box } from '@chakra-ui/react';

/**
 * Container is used to ensure consistent widths and paddings between all pages.
 * It accepts all of the same props as the Box component, as it effectively a
 * Box component with some opinionated defaults for padding, maxWidth and horizontal margin (auto).
 */
var Container = function Container(props) {
  return (
    /*#__PURE__*/
    // wrapping Box to counteract a child Stack component
    // from removing margin
    React.createElement(Box, null, /*#__PURE__*/React.createElement(Box, _extends({
      paddingX: "gutter",
      maxWidth: ['full', null, null, '7xl'],
      mx: "auto"
    }, props)))
  );
};

export { Container };
